"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[97323],{

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 10567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-body {\n    padding: 20px;\n  }\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3a0d262d-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Box);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, DESKTOP_APP_BUCKET, DESKTOP_APP_SECRET_KEY, DESKTOP_APP_ACCESS_KEY, DESKTOP_APP_URL, DESKTOP_APP_END_POINT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://ui.lab.stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.lab.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v25-staging";
var API_VERSION_ALT = "exodus-migration" || 0;
var API_BASE_URL = "".concat("https://api.lab.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.lab.stockbit.com";
var API_TRADING_URL = "https://trading.lab.masonline.id";
var API_TRADING_URL_V2 = "https://trading-core.lab.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.lab.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api.trading-lab.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.lab.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.lab.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit-stream-dev.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.sandbox.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.lab.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_BUCKET = (/* unused pure expression or super */ null && ("sb-sda-release"));
var DESKTOP_APP_SECRET_KEY = (/* unused pure expression or super */ null && ("EFKHBWQHWq0jWNNGM2/e35vU4vOrN4OHyd4f09Kv"));
var DESKTOP_APP_ACCESS_KEY = (/* unused pure expression or super */ null && ("AKIAX4CD7C6D4DF5LTF6"));
var DESKTOP_APP_URL = (/* unused pure expression or super */ null && ("https://sda-release.stockbit.com/"));
var DESKTOP_APP_END_POINT = (/* unused pure expression or super */ null && ("https://s3.ap-southeast-3.amazonaws.com/"));
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.com.stockbitdev.ios"));



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
var PROJECT_FOLDER = "staging";
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://ui.lab.stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-WWZ885M" || 0;
var siteUrl = "https://ui.lab.stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "TEST-7ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.lab.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "9961bcff-8da8-43a1-917e-39d352a4a0dd" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 81422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lk": function() { return /* binding */ address; },
/* harmony export */   "m7": function() { return /* binding */ phone; },
/* harmony export */   "sJ": function() { return /* binding */ supportEmail; },
/* harmony export */   "uM": function() { return /* binding */ companyEmail; },
/* harmony export */   "ub": function() { return /* binding */ companyName; },
/* harmony export */   "z8": function() { return /* binding */ marketingEmail; }
/* harmony export */ });
var companyName = "PT Stockbit Sekuritas Digital";
var address = "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta 12930";
var supportEmail = "support@stockbit.com";
var phone = "+62 21 50959-330";
var marketingEmail = "marketing@stockbit.com";
var companyEmail = "company@stockbit.com";


/***/ }),

/***/ 97323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ features_about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/HomePageLayout/index.tsx + 10 modules
var HomePageLayout = __webpack_require__(22647);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/features/about/styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px;\n  margin: 50px auto;\n  height: 100%;\n  \n  @media ",
        " {\n    padding: 0;\n    max-width: 1300px;\n    width: calc(100% - 150px);\n    margin: 150px auto;\n  }\n}"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 100px 0;\n\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: 1fr;\n    grid-column-gap: 25px;\n    grid-row-gap: 0px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  margin-bottom: 25px;\n\n  .address {\n    margin: 22px;\n    background: url(",
        "/images/pin.png) no-repeat top left;\n    padding-left: 68px;\n  }\n\n  h5 {\n    font-size: 16px;\n\n    @media ",
        " {\n      font-size: 24px;\n      margin-bottom: 10px;\n    }\n  }\n\n  p {\n    font-size: 14px;\n\n    @media ",
        " {\n      font-size: 18px;\n      margin-bottom: 20px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 40px;\n  margin-bottom: ",
        ";\n\n  @media ",
        " {\n    font-size: 26px;\n  }\n\n  @media ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 30px;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    font-size: 20px;\n  }\n\n  @media ",
        " {\n    font-size: 30px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-ab95279-0"
})(_templateObject(), device/* default.tablet */.Z.tablet);
var AboutContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-ab95279-1"
})(_templateObject1());
var AboutContainerInner = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab95279-2"
})(_templateObject2(), device/* default.laptop */.Z.laptop);
var Paragraph = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "p",
    size: "18px",
    mt: "24px;",
    align: "justify"
}).withConfig({
    componentId: "sc-ab95279-3"
})(_templateObject3());
var ContactContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab95279-4"
})(_templateObject4(), device/* default.laptop */.Z.laptop);
var ContactBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab95279-5"
})(_templateObject5(), color/* default.gainsboro */.Z.gainsboro, app/* assetPrefix */.Vc, device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet);
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "h3",
    family: "bold"
}).withConfig({
    componentId: "sc-ab95279-6"
})(_templateObject6(), function(props) {
    return props.mb ? props.mb : "20px";
}, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var MiniTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "h3",
    family: "bold"
}).withConfig({
    componentId: "sc-ab95279-7"
})(_templateObject7(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);

;// CONCATENATED MODULE: ./src/features/about/constants.ts
var timelines = [
    {
        year: 2000,
        desc: "Perubahan Management dan Kepemilikan"
    },
    {
        year: 2007,
        desc: "Menggunakan ‘Remote Trading’"
    },
    {
        year: 2009,
        desc: "Berpartisipasi dalam Transaksi Negosiasi PT Adaro Energy senilai Rp15,73 Triliun"
    },
    {
        year: 2021,
        desc: "Terdaftar di KSEI dan IDX sebagai sekuritas yang dapat melakukan pembukaan rekening efek secara digital "
    },
    {
        year: 2021,
        desc: "Perubahan Manajemen & Kepemilikian dari PT Mahakarya Artha Sekuritas menjadi PT Stockbit Sekuritas Digital "
    }, 
];
var managements = [
    {
        name: "Bacelius Ruru",
        position: "Komisaris Utama & Independen",
        desc: "Menjabat resmi sebagai Komisaris Utama dan Independen PT Stockbit Sekuritas Digital sejak tahun 2021, beliau meniti karir pada Departemen Keuangan dan menduduki sejumlah jabatan penting di lingkungan Departemen Keuangan dan Kementerian BUMN, antara lain Ketua Badan Pengawas Pasar Modal ‘Bapepam’(1993-1995) selanjutnya, menjadi Komisaris Utama PT Bursa Efek Indonesia periode 2001-2008."
    },
    {
        name: "Wellson Lo",
        position: "Komisaris",
        desc: "Menjabat resmi sebagai Komisaris PT. Stockbit Sekuritas Digital sejak tahun 2022, beliau merupakan Lulusan Bachelor of Accounting and Finance dari University of Melbourne dan Master in Finance dari Monash University dimana memiliki pengalaman\xa0 selama 4 tahun dalam bidang audit, analis saham dan financial controller di Singapura dan Jakarta."
    },
    {
        name: "Megawati Andrew Soewardi",
        position: "Direktur Utama",
        desc: "Menjabat resmi sebagai Direktur Utama PT. Stockbit Sekuritas Digital, beliau mengawali karirnya di Industri Pasar Modal sejak tahun 1997. Pada tahun 2012, beliau diangkat menjadi Direktur Utama PT. Mahakarya Artha Securities hingga perusahaan berganti nama sekarang menjadi PT Stockbit Sekuritas Digital."
    },
    {
        name: "Jason Terence Halim",
        position: "Direktur",
        desc: "Menjabat resmi sebagai Direktur PT. Stockbit Sekuritas Digital, beliau mengawali karirnya di Industri Pasar Modal sejak tahun 2007. Pada tahun 2011, beliau diangkat menjadi Direktur PT. Mahakarya Artha Securities hingga perusahaan berganti nama menjadi PT Stockbit Sekuritas Digital."
    },
    {
        name: "Jana Lukito",
        position: "Direktur",
        desc: "Menjabat resmi sebagai Direktur PT. Stockbit Sekuritas Digital, beliau memiliki latar belakang keuangan dan mengawali karirnya di Industri Pasar Modal sejak tahun 2001. Beliau juga diangkat menjadi Direktur PT. Mahakarya Artha Securities sejak tahun 2001 hingga sekarang dimana perusahaan berganti nama menjadi PT Stockbit Sekuritas Digital."
    }, 
];
var licenseHolder = [
    {
        name: "Dewan Komisaris",
        position: "Pemegang Lisensi  WPPE OJK",
        count: 1
    },
    {
        name: "Direksi",
        position: "Pemegang Lisensi  WPPE OJK",
        count: 3
    },
    {
        name: "Karyawan",
        position: "Pemegang Lisensi  WPPE OJK",
        count: 18
    },
    {
        name: "Karyawan",
        position: "Pemegang Lisensi  WPEE OJK",
        count: 1
    }, 
];

;// CONCATENATED MODULE: ./src/features/about/about/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px;\n  border-radius: 12px;\n  box-sizing: border-box;\n  border: 1px solid ",
        ";\n  margin-bottom: 80px;\n\n  @media ",
        " {\n    margin-bottom: 40px;\n  }\n\n  @media ",
        " {\n    width: 42%;\n    margin-right: 3%;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: 50%;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url(",
        "/images/dot.svg) no-repeat;\n  padding-left: 45px;\n  min-height: 50px;\n  margin-bottom: 30px;\n  background-position: 0 20px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  margin-top: 3px;\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var TimelineBox = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9b25c831-0"
})(styled_templateObject(), color/* default.downgray */.Z.downgray, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var CompanyInfo = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9b25c831-1"
})(styled_templateObject1(), device/* default.laptop */.Z.laptop);
var Timeline = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9b25c831-2"
})(styled_templateObject2(), app/* assetPrefix */.Vc);
var TimelineTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "p",
    family: "bold"
}).withConfig({
    componentId: "sc-9b25c831-3"
})(styled_templateObject3(), device/* default.tablet */.Z.tablet);

;// CONCATENATED MODULE: ./src/features/about/about/index.tsx





var AboutUs = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainerInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineBox, {
                    children: timelines.map(function(timeline) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    as: "p",
                                    size: "16px",
                                    children: timeline.year
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineTitle, {
                                    children: timeline.desc
                                })
                            ]
                        }, timeline.year);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfo, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "Informasi Perusahaan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                            children: "Berdiri sejak tahun 1990 dengan nama PT Mahakarya Artha Sekuritas dan terdaftar di OJK dengan nomor izin KEP-132/PM/1992, PT Mahakarya Artha Sekuritas terus berkomitmen dalam meningkatkan jumlah investor di Indonesia untuk membantu perekonomian nasional. Pada Desember 2021, PT Mahakarya Artha Sekuritas telah resmi diakuisisi dan berganti nama menjadi PT Stockbit Sekuritas Digital."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                            children: "Sebagai perusahaan efek yang telah memiliki pengalaman, PT Stockbit Sekuritas Digital berkomitmen untuk terus melakukan inovasi dan memberikan layanan serta pengalaman investasi yang mudah, aman dan terpercaya bagi investor melalui teknologi kelas dunia untuk dapat memfasilitasi masyarakat dalam berinvestasi secara mudah di pasar modal Indonesia melalui layanan perdagangan saham online yang modern. Melalui aplikasi investasi sosial Stockbit investor dapat berdiskusi sekaligus melakukan transaksi saham secara daring. Pembukaan akun rekening sekuritas juga dapat dilakukan melalui aplikasi Stockbit yang dapat diunduh melalui Playstore dan Appstore."
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var about = (AboutUs);

;// CONCATENATED MODULE: ./src/features/about/vision/styled.ts

function vision_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column-reverse;\n  margin-top: 32px;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    vision_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function vision_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: calc(100% - 250px);\n    display: flex;\n    width: 100%;\n    align-items: center;\n    padding: 16px 80px 16px 16px;\n    border: 1px solid #ededed;\n    border-radius: 12px;\n  }\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    vision_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function vision_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    h3 {\n      text-align: center;\n    }\n  }\n\n  @media ",
        " {\n    flex: 1;\n\n    h3 {\n      text-align: left;\n    }\n  }\n\n  ul {\n    padding-left: 30px;\n    padding-top: 16px;\n  }\n"
    ]);
    vision_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function vision_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 200px;\n  margin-bottom: 40px;\n\n  @media ",
        " {\n    width: 250px;\n    margin-bottom: 0;\n  }\n\n  @media ",
        " {\n    width: auto;\n  }\n"
    ]);
    vision_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    display: flex;\n    justify-content: center;\n  }\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var VisionContainer = (0,styled_components_browser_esm/* default */.ZP)(AboutContainerInner).withConfig({
    componentId: "sc-b665f73b-0"
})(vision_styled_templateObject(), device/* default.tablet */.Z.tablet);
var VisionMissionBox = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b665f73b-1"
})(vision_styled_templateObject1(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var VisMisBox = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b665f73b-2"
})(vision_styled_templateObject2(), device/* default.mobileS */.Z.mobileS, device/* default.tablet */.Z.tablet);
var VisionImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-b665f73b-3"
})(vision_styled_templateObject3(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var VisionImageContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b665f73b-4"
})(styled_templateObject4(), device/* default.mobileS */.Z.mobileS, device/* default.tablet */.Z.tablet);

;// CONCATENATED MODULE: ./src/features/about/vision/index.tsx



var Vision = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                align: "center",
                mb: "50px",
                children: "Visi & Misi Perusahaan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionContainer, {
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisionMissionBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionImageContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionImage, {
                                src: "/images/vision.svg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisMisBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniTitle, {
                                    children: "Visi Perusahaan"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    children: "Membantu masyarakat Indonesia mencapai masa depan yang lebih baik melalui investasi."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisionMissionBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionImageContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionImage, {
                                src: "/images/mission.svg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisMisBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniTitle, {
                                    children: "Misi Perusahaan"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Menyediakan sarana investasi pasar modal yang mudah, aman dan nyaman untuk pemula."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Meningkatkan literasi keuangan dengan meningkatkan edukasi dan kesadaran berinvestasi."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Berkontribusi dalam menciptakan layanan jasa keuangan di bidang pasar modal yang inklusif."
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var vision = (Vision);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
;// CONCATENATED MODULE: ./src/features/about/management/styled.tsx

function management_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: calc(100% - 400px);\n    margin-right: 40px;\n  }\n"
    ]);
    management_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function management_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    management_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function management_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-column-gap: 28px;\n  grid-row-gap: 28px;\n  flex-direction: column;\n\n  &:last-child {\n    > div:first-child {\n      grid-column: 1 / span 2;\n      margin-bottom: 0;\n      margin-top: 28px;\n    }\n  }\n\n  @media ",
        " {\n    flex-direction: column;\n    display: flex;\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    management_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function management_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n  border-radius: 12px;\n  box-sizing: border-box;\n  border: ",
        ";\n  margin: 14px 0px;\n  min-height: 100%;\n\n  /** &:not(.position-3) {\n    width: calc(50% - 14px);\n    float: left;\n  }\n\n  &.position-1,\n  &.position-4 {\n    margin-right: 14px;\n  }\n\n  &.position-2,\n  &.position-5 {\n    margin-left: 14px;\n  } **/\n\n  @media ",
        " {\n    padding: 40px;\n    min-height: 1px;\n  }\n\n  @media ",
        " {\n    width: 33%;\n    margin: 20px 10px;\n    min-height: 1px;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    border: 2px solid #00ab6b;\n  }\n"
    ]);
    management_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function management_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body {\n    padding: 40px;\n    border-radius: 12px;\n  }\n\n  .ant-modal-close {\n    display: none;\n    visibility: hidden;\n    opacity: 0;\n  }\n"
    ]);
    management_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var VisionBox = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-bc305794-0"
})(management_styled_templateObject(), device/* default.tablet */.Z.tablet);
var styled_VisionImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-bc305794-1"
})(management_styled_templateObject1(), device/* default.tablet */.Z.tablet);
var ManagementContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "flex-start",
    justify: "center"
}).withConfig({
    componentId: "sc-bc305794-2"
})(management_styled_templateObject2(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc305794-3"
})(management_styled_templateObject3(), function(props) {
    return props.active ? "2px solid #00AB6B" : "1px solid #ededed";
}, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-bc305794-4"
})(management_styled_templateObject4());

;// CONCATENATED MODULE: ./src/features/about/management/index.tsx









var Person = function(param) {
    var name = param.name, position = param.position, desc = param.desc, showDesc = param.showDesc;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                family: "bold",
                size: showDesc ? "30px" : "22px",
                mt: "4px",
                mb: "4px",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                family: "bold",
                size: showDesc ? "20px" : "16px",
                mt: "4px",
                color: color/* default.suvaGrey */.Z.suvaGrey,
                children: position
            }),
            showDesc && // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "p",
                size: "18px",
                mt: "24px",
                align: "justify",
                children: desc
            })
        ]
    });
};
var Management = function() {
    var defaultModalData = {
        name: "",
        position: "",
        desc: ""
    };
    var ref = (0,react.useState)(false), showModalManagement = ref[0], setShowModalManagement = ref[1];
    var ref1 = (0,react.useState)(defaultModalData), modalData = ref1[0], setModalData = ref1[1];
    var toggleModal = function(params) {
        setShowModalManagement(params);
    };
    var showModal = function(management) {
        toggleModal(true);
        setModalData(management);
    };
    var closeModal = function() {
        toggleModal(false);
        setModalData(defaultModalData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                align: "center",
                mb: "60px",
                children: "Manajemen"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagementContainer, {
                children: managements.slice(0, 2).map(function(management) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                        active: management.name === modalData.name,
                        onClick: function() {
                            return showModal(management);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, management), {
                            showDesc: false
                        }), management.name)
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagementContainer, {
                children: managements.slice(2, 6).map(function(management) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                        active: management.name === modalData.name,
                        onClick: function() {
                            return showModal(management);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, management), {
                            showDesc: false
                        }), management.name)
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Modal, {
                visible: showModalManagement,
                onCancel: closeModal,
                centered: true,
                width: 700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalData), {
                    showDesc: true
                }))
            })
        ]
    });
};
/* harmony default export */ var management = (Management);

// EXTERNAL MODULE: ./src/constants/company.js
var company = __webpack_require__(81422);
// EXTERNAL MODULE: ./src/features/static/GoogleMap.tsx
var GoogleMap = __webpack_require__(54690);
;// CONCATENATED MODULE: ./src/features/about/contact/styled.ts

function contact_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: 1fr;\n    grid-column-gap: 25px;\n    grid-row-gap: 0px;\n  }\n"
    ]);
    contact_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function contact_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  margin-bottom: 25px;\n\n  &.map {\n    height: 320px;\n\n    @media ",
        " {\n      height: 608px;\n    }\n\n    @media ",
        " {\n      height: auto;\n    }\n  }\n"
    ]);
    contact_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function contact_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url(",
        "/",
        ") no-repeat top left;\n  padding: 0 20px 20px 75px;\n  background-position: 20px 0;\n  background-size: 32px 32px;\n  word-break: break-word;\n\n  @media ",
        " {\n    padding: 0 30px 30px 98px;\n    background-position: 30px 0;\n    background-size: 48px 48px;\n    word-break: normal;\n  }\n\n  &:first-child {\n    padding-top: 20px;\n    background-position: 20px 20px;\n    @media ",
        " {\n      padding-top: 30px;\n      background-position: 30px 30px;\n    }\n  }\n\n  p {\n    font-size: 19px;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  h5 {\n    font-size: 19px;\n  }\n"
    ]);
    contact_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var styled_ContactContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b659eec8-0"
})(contact_styled_templateObject(), device/* default.laptop */.Z.laptop);
var styled_ContactBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b659eec8-1"
})(contact_styled_templateObject1(), color/* default.gainsboro */.Z.gainsboro, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var ContactItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b659eec8-2"
})(contact_styled_templateObject2(), app/* assetPrefix */.Vc, function(props) {
    return props.icon;
}, device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet);

;// CONCATENATED MODULE: ./src/features/about/contact/index.tsx






var Contact = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                align: "center",
                mb: "60px",
                children: "Hubungi Kami"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_ContactContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_ContactBox, {
                        className: "map",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMap/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_ContactBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                                icon: "images/location.svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "h5",
                                        family: "bold",
                                        mb: "15px",
                                        size: "19px",
                                        children: company/* companyName */.ub
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        children: company/* address */.Lk
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                                icon: "images/email.svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "h5",
                                        family: "bold",
                                        mb: "15px",
                                        size: "19px",
                                        children: "Kontak Utama"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                                        children: [
                                            "Untuk segala pertanyaan dan masalah, kamu dapat mengunjungi pusat bantuan kami. Jika kamu membutuhkan bantuan lebih jauh, kamu dapat mengirimkan email ke",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                as: "b",
                                                family: "bold",
                                                size: "19px",
                                                children: company/* supportEmail */.sJ
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                                icon: "images/phone.svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "h5",
                                        family: "bold",
                                        mb: "15px",
                                        size: "19px",
                                        children: "Telepon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        children: company/* phone */.m7
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contact = (Contact);

;// CONCATENATED MODULE: ./src/features/about/LicenseHolder/styled.tsx

function LicenseHolder_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-top: 60px;\n\n  @media ",
        " {\n    margin-bottom: 160px;\n  }\n"
    ]);
    LicenseHolder_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LicenseHolder_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 47%;\n  border: 1px solid #EDEDED;\n  padding: 40px 50px;\n  border-radius: 12px;\n  margin-bottom: 40px;\n  \n  @media ",
        " {\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  @media ",
        " {\n    width: 47%;\n  }\n"
    ]);
    LicenseHolder_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LicenseHolder_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  align-items: center;\n  height: 93px;\n  width: 93px;\n  border: 2px solid #EDEDED;\n  border-radius: 50%;\n  margin-right: 40px;\n\n  p{\n    color: #00BF71;\n  }\n\n  @media ",
        " {\n    height: 70px;\n  }\n  \n  @media ",
        " {\n    height: 93px;\n  }\n"
    ]);
    LicenseHolder_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LicenseHolder_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  flex-wrap: wrap\n  h5{\n    color: #949494;\n  }\n  \n  @media ",
        " {\n    height: auto;\n\n    h3{\n      font-size: 26px;\n    }\n\n    h5{\n      font-size: 16px;\n    }\n  }\n\n  @media ",
        " {\n    height: 93px;\n  }\n"
    ]);
    LicenseHolder_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var LicenseHolderContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-718f8f1d-0"
})(LicenseHolder_styled_templateObject(), device/* default.laptop */.Z.laptop);
var LicenseHolderBox = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-718f8f1d-1"
})(LicenseHolder_styled_templateObject1(), device/* default.mobileS */.Z.mobileS, device/* default.laptop */.Z.laptop);
var LicenseCount = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-718f8f1d-2"
})(LicenseHolder_styled_templateObject2(), device/* default.mobileS */.Z.mobileS, device/* default.tablet */.Z.tablet);
var LicenseDesc = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-718f8f1d-3"
})(LicenseHolder_styled_templateObject3(), device/* default.mobileS */.Z.mobileS, device/* default.tablet */.Z.tablet);

;// CONCATENATED MODULE: ./src/features/about/LicenseHolder/index.tsx







var LicenseHolderData = function(param) {
    var name = param.name, position = param.position, count = param.count;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LicenseHolderBox, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseCount, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    size: "36px",
                    family: "bold",
                    mb: "0",
                    children: count
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LicenseDesc, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "h3",
                        family: "bold",
                        size: "30px",
                        color: color/* default.highempahis */.Z.highempahis,
                        mb: "12px",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "h5",
                        size: "26px",
                        children: position
                    })
                ]
            })
        ]
    });
};
var LicenseHolder_Contact = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                align: "center",
                mb: "80px",
                children: "Pemegang Lisensi"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolderContainer, {
                children: licenseHolder.map(function(data) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolderData, (0,_object_spread/* default */.Z)({}, data), data.count);
                })
            })
        ]
    });
};
/* harmony default export */ var LicenseHolder = (LicenseHolder_Contact);

;// CONCATENATED MODULE: ./src/features/about/index.tsx











var GuestAbout = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePageLayout["default"], {
        hideStartInvesting: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "About Us | Stockbit - Komunitas Saham Indonesia"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(about, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(vision, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(management, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                align: "center",
                                mb: "60px",
                                children: "Susunan organisasi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                align: "center",
                                justify: "center",
                                margin: "0 0 160px 0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/organizationNew2.svg"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseHolder, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var features_about = (GuestAbout);


/***/ }),

/***/ 54690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61014);


var GoogleMap = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .GoogleMap */ .b6, {
        src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.347473842258!2d106.8164691147692!3d-6.217826195498961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3fba19560d7%3A0xc7fa648c0764c955!2sStockbit!5e0!3m2!1sen!2sid!4v1640226301166!5m2!1sen!2sid",
        allowFullScreen: true,
        loading: "lazy",
        title: "Stockbit on Map"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GoogleMap);


/***/ }),

/***/ 61014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LV": function() { return /* binding */ ArticleBox; },
/* harmony export */   "b6": function() { return /* binding */ GoogleMap; },
/* harmony export */   "dl": function() { return /* binding */ NavigationWrapper; },
/* harmony export */   "mI": function() { return /* binding */ ArticleContainer; },
/* harmony export */   "v2": function() { return /* binding */ Menu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_statics_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10567);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 24px;\n  width: 130px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  line-height: 30px;\n  width: 130px;\n\n  @media screen and (max-width: 600px) {\n    width: 100px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  border: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n\n  @media screen and (min-width: 740px) {\n    max-width: 740px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14.5px;\n  width: 100%;\n  ul {\n    padding-left: 20px;\n  }\n\n  ol {\n    padding-left: 20px;\n  }\n\n  p + ul {\n    margin-top: -10px;\n  }\n\n  h3 {\n    font-weight: normal;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var NavigationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f29667c0-0"
})(_templateObject());
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    as: "a",
    size: "14.5px"
}).withConfig({
    componentId: "sc-f29667c0-1"
})(_templateObject1());
var GoogleMap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    componentId: "sc-f29667c0-2"
})(_templateObject2());
var ArticleBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_deprecated_ui_statics_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f29667c0-3"
})(_templateObject3());
var ArticleContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    componentId: "sc-f29667c0-4"
})(_templateObject4());



/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ })

}]);